import script from "./WithdrawActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawActions.vue?vue&type=script&setup=true&lang=ts"

export default script